import React from "react";

import {
  ConfirmSignUp,
  ForgotPassword,
  Greetings,
  Loading,
  RequireNewPassword,
  SignIn,
  SignUp,
} from "aws-amplify-react";

import "scenes/Login/Login.css";
import "react-datepicker/dist/react-datepicker.css";
import "css/general.css";
import "css/animation.css";
import "css/segment_toggle.css";

import HublySignIn from "../../scenes/Login";
import HublyAuthenticator from "../../scenes/Login/components/HublyAuthenticator";
import HublyConfirmSignUp from "../../scenes/Login/components/HublyConfirmSignUp";
import HublyForgotPassword from "../../scenes/Login/components/HublyForgotPassword";
import HublyLoading from "../../scenes/Login/components/HublyLoading";
import HublyRequireNewPassword from "../../scenes/Login/components/HublyRequireNewPassword";
import HublySignUp from "../../scenes/Login/components/HublySignUp";
import HublySignUpLinkHandler from "../../scenes/Login/components/HublySignUpLinkHandler";

const map = (message) => {
  if (/incorrect.*username.*password/i.test(message)) {
    return "Incorrect username or password";
  }
  if (/null.*failed.*with.*error/i.test(message)) {
    return "Password cannot be empty";
  }
  return message;
};

class LegacyAuthenticationRoutes extends React.Component {
  state = {
    emailAddress: "",
  };

  setEmailAddress = (email) => {
    this.setState({ emailAddress: email });
  };

  render() {
    const { emailAddress } = this.state;
    return (
      <HublyAuthenticator
        errorMessage={map}
        hide={[
          ConfirmSignUp,
          ForgotPassword,
          Greetings,
          Loading,
          SignIn,
          SignUp,
          RequireNewPassword,
        ]}
      >
        <HublyConfirmSignUp />
        <HublyForgotPassword />
        <HublyLoading />
        <HublySignIn setEmailAddress={this.setEmailAddress} />
        <HublySignUpLinkHandler onEmailIsReady={this.setEmailAddress} />
        <HublySignUp emailAddress={emailAddress} />
        <HublyRequireNewPassword emailAddress={emailAddress} />
      </HublyAuthenticator>
    );
  }
}

export default LegacyAuthenticationRoutes;
